import { forEach, remove } from 'lodash';

export default class Emitter {
	_handlers;

	constructor() {
		this._handlers = {};
	}

	on(message, handler) {
		if (typeof message === 'undefined') {
			throw new Error('No message provided to subscribe to.');
		}

		if (typeof handler === 'undefined') {
			throw new Error('No handler provided.');
		}

		message.split(' ').forEach((x) => {
			this._handlers[x] = this._handlers[x] || [];
			this._handlers[x].push(handler);
		});

		return this;
	}

	off(handler) {
		const filter = (h) => h === handler;

		forEach(this._handlers, (v) => {
			remove(v, filter);
		});

		return this;
	}

	clear(message) {
		if (message) {
			this._handlers[message] = [];
		} else {
			this._handlers = {};
		}
	}

	trigger(message, ...args) {
		// first param is the message name. all additional parameters will be passed to the registered callbacks for the provided message name.
		if (typeof message === 'undefined') {
			throw new Error('No message provided with call to Emitter.trigger.');
		}

		// var args = Array.prototype.slice.call(arguments).splice(1);
		const parts = message.split('.');

		while (parts.length > 0) {
			const handlers = this._handlers[parts.join('.')];
			if (handlers) {
				handlers.forEach((h) => h(...args));
			}

			parts.pop();
		}

		return this;
	}
}
